module.exports = __webpack_public_path__ + "img/avatar_cactus.047bd0b9.png";